import React from "react";
import { motion } from "framer-motion"; // optional for animation, remove if not needed

const WhatsAppChat = ({
  phoneNumber = "917300863123", // Replace with your business number
  message = "Hello, I need some help!",
}) => {
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;

  return (
    <motion.a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ type: "spring", stiffness: 300, damping: 15 }}
      className="fixed bottom-5 right-5 z-50 flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:scale-110 transition-transform duration-300"
    >
      {/* WhatsApp Icon (SVG) */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="white"
        viewBox="0 0 24 24"
        className="w-7 h-7"
      >
        <path d="M20.52 3.48A11.88 11.88 0 0012 0C5.37 0 0 5.37 0 12c0 2.11.55 4.18 1.59 6.01L0 24l6.26-1.64A11.94 11.94 0 0012 24c6.63 0 12-5.37 12-12 0-3.19-1.24-6.19-3.48-8.52zM12 22c-1.87 0-3.7-.5-5.29-1.44l-.38-.22-3.72.98 1-3.63-.25-.38A9.94 9.94 0 012 12C2 6.48 6.48 2 12 2c2.65 0 5.14 1.03 7.02 2.9A9.91 9.91 0 0122 12c0 5.52-4.48 10-10 10zm5.01-7.39c-.27-.14-1.62-.8-1.87-.9-.25-.09-.43-.14-.62.14-.19.27-.71.89-.87 1.08-.16.18-.32.2-.59.07-.27-.14-1.15-.42-2.2-1.34-.81-.72-1.36-1.6-1.52-1.87-.16-.27-.02-.42.12-.56.12-.12.27-.32.41-.48.14-.16.18-.27.27-.46.09-.18.05-.34-.02-.48-.07-.14-.62-1.49-.85-2.04-.22-.53-.44-.46-.62-.46h-.53c-.18 0-.48.07-.73.34-.25.27-.96.94-.96 2.29s.99 2.66 1.13 2.84c.14.18 1.95 2.98 4.73 4.17.66.28 1.18.45 1.59.58.67.21 1.28.18 1.76.11.54-.08 1.62-.66 1.85-1.3.23-.64.23-1.18.16-1.3-.07-.11-.25-.18-.52-.32z" />
      </svg>
    </motion.a>
  );
};

export default WhatsAppChat;
